import { render, staticRenderFns } from "./GlobalHome.vue?vue&type=template&id=65e87063&scoped=true"
import script from "./GlobalHome.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalHome.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GlobalHome.vue?vue&type=style&index=0&id=65e87063&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e87063",
  null
  
)

export default component.exports